import React from "react";
import Reveal from "./Reveal";

/**
 * Editorial section header with two layouts:
 * - "split": eyebrow + title left, lede + action right (desktop)
 * - "stacked": everything in one column
 * tone: "light" (on white) | "dark" (on ink bands)
 */
const SectionHeader = ({
  index,
  eyebrow,
  title,
  lede,
  action = null,
  layout = "split",
  tone = "light",
  className = "",
}) => {
  const dark = tone === "dark";
  const split = layout === "split";

  return (
    <div className={className}>
      <Reveal>
        <div className="flex items-center gap-3">
          <span className="tick" aria-hidden="true" />
          {index && (
            <span
              className={`font-mono text-xs tracking-[0.25em] ${
                dark ? "text-white/50" : "text-gray-400"
              }`}
            >
              {index}
            </span>
          )}
          <p
            className={`text-xs font-bold tracking-[0.25em] uppercase ${
              dark ? "text-white/80" : "text-designer-primary"
            }`}
          >
            {eyebrow}
          </p>
        </div>
      </Reveal>

      <div
        className={
          split
            ? "mt-5 grid gap-6 lg:grid-cols-[1.4fr_1fr] lg:items-end"
            : "mt-5 max-w-3xl space-y-5"
        }
      >
        <Reveal delay={80}>
          <h2
            className={`text-balance font-display font-extrabold tracking-tight leading-[1.04] text-3xl sm:text-4xl lg:text-5xl ${
              dark ? "text-white" : "text-designer-dark"
            }`}
          >
            {title}
          </h2>
        </Reveal>
        {(lede || action) && (
          <Reveal delay={160} className={split ? "lg:justify-self-end lg:max-w-md" : ""}>
            {lede && (
              <p
                className={`text-base md:text-lg leading-relaxed ${
                  dark ? "text-white/65" : "text-gray-600"
                }`}
              >
                {lede}
              </p>
            )}
            {action && <div className="mt-5">{action}</div>}
          </Reveal>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
